import type { LocationDescriptor } from 'history';
import type { HTMLAttributes, MouseEventHandler } from 'react';

export interface CardItemLitterData {
  id?: number;
  image?: string;
  breed: string;
  price: string;
  location: string;
  futureLitter?: {
    year: string;
    month: string;
  };
  breeder?: CardItemLitterDataBreeder;
  onClick?: MouseEventHandler;
  link?: LocationDescriptor;
  onWishlistClick?: MouseEventHandler;
  isWishlisted?: boolean;
  hasPedigreeFciBadge?: boolean;
  hasPedigreeBadge?: boolean;
  loading?: boolean;
  lazyLoadImage?: boolean;
  useHeadingForTitle?: boolean;
}

export interface CardItemLitterDataBreeder {
  name: string;
  personName: string;
  image?: string;
  onClick?: MouseEventHandler;
  rating?: {
    average: number;
    amount: number;
  };
}

export interface CardItemLitterProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onClick' | 'id'>,
    CardItemLitterData {}
